import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { useToaster } from 'utils/useToaster'
import { SignUpCard } from 'sharedComponents/SignUpCard'
import { EmptyCenteredLayout } from 'client-portal/components/PageLayout'

interface RouteParams {
  token: string
}

export const SignUp: React.VFC<RouteComponentProps<RouteParams>> = ({ match, history }) => {
  const { setToastMessage } = useToaster()
  const { token } = match.params

  return (
    <EmptyCenteredLayout>
      <SignUpCard
        token={token}
        title="Sign up to ModMD"
        passwordLabel="Password"
        passwordPlaceholder="Enter your password"
        passwordConfirmationLabel="Password Confirmation"
        passwordConfirmationPlaceholder="Enter your password again"
        signUpButtonLabel="Sign up"
        alreadyHaveAccountLabel="Already have account?"
        signInButtonLabel="Sign in"
        onSignInButtonOnClick={() => history.push('/')}
        onSignUpSuccess={() => {
          setToastMessage('Successfully signed up!', 'success')
          history.push('/')
        }}
      />
    </EmptyCenteredLayout>
  )
}
